export const JDID_KEY = 'jdid';
export const TWO_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 2;
const NANOID_LENGTH = 21;

/**
 * Validates that a JDID is in the expected nanoid format.
 */
export function isValidJdid(jdid: string | null | undefined): jdid is string {
  return typeof jdid === 'string' && jdid.length === NANOID_LENGTH;
}
